import { render, staticRenderFns } from "./ModuleItem.vue?vue&type=template&id=3694dd84"
import script from "./ModuleItem.vue?vue&type=script&lang=js"
export * from "./ModuleItem.vue?vue&type=script&lang=js"
import style0 from "./ModuleItem.vue?vue&type=style&index=0&id=3694dd84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports